import React from 'react';
import secondSection from '../assets/images/secondSection.jpg';
import secondSection1 from '../assets/images/secondSection1.jpg';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './StorySection.css';

const StorySection = () => {
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.6);
  const [textRef, isTextVisible] = useScrollAnimation(0.7);
  const [imageRef, isImageVisible] = useScrollAnimation(0.8);
  const [gridRef, isGridVisible] = useScrollAnimation(0.7);
  const [mobileRef, isMobileVisible] = useScrollAnimation(0.8);

  return (
    <section ref={sectionRef} className="story-section">
      <div className="story-container">
        {/* Original Layout for < 1200px */}
        <div className="story-content">
          <div ref={textRef} className={`story-text ${isTextVisible ? 'visible' : ''}`}>
            <h2 className={`story-title text-reveal ${isTextVisible ? 'visible' : ''}`}>
              <span className="title-line-1">THE INDUS</span>
              <span className="title-line-2">TRADE STORY</span>
            </h2>
            <p className={`story-description text-reveal stagger-1 ${isTextVisible ? 'visible' : ''}`}>
              Indus Trade is a professionally managed trade only organization intending to establish Indian Furniture as the trendsetter in world furniture marketplace.
            </p>
            <p className={`story-tagline text-reveal stagger-2 ${isTextVisible ? 'visible' : ''}`}>
              Blending Tradition, Technology, and Trust.
            </p>
          </div>
          
          <div ref={imageRef} className={`story-images ${isImageVisible ? 'visible' : ''}`}>
            <div className={`fade-in ${isImageVisible ? 'visible' : ''}`}>
              <img src={secondSection} alt="Indus Trade Factory Building" className={`story-image image-reveal ${isImageVisible ? 'visible' : ''}`} />
            </div>
            <div className={`fade-in stagger-1 ${isImageVisible ? 'visible' : ''}`}>
              <img src={secondSection1} alt="Woodworking Workshop" className={`story-image image-reveal ${isImageVisible ? 'visible' : ''}`} />
            </div>
          </div>
        </div>
        
        {/* Grid Layout for >= 1200px */}
        <div ref={gridRef} className={`story-grid ${isGridVisible ? 'visible' : ''}`}>
          {/* Row 1 */}
          <div className={`grid-item grid-title fade-in ${isGridVisible ? 'visible' : ''}`}>
            <h2 className={`story-title text-reveal ${isGridVisible ? 'visible' : ''}`}>
              <span className="title-line-1">THE INDUS</span>
              <span className="title-line-2">TRADE STORY</span>
            </h2>
          </div>
          
          <div className={`grid-item grid-description fade-in stagger-1 ${isGridVisible ? 'visible' : ''}`}>
            <p className={`story-description text-reveal ${isGridVisible ? 'visible' : ''}`}>
              Indus Trade is a professionally managed trade only organization intending to establish Indian Furniture as the trendsetter in world furniture marketplace.
            </p>
          </div>
          
          <div className={`grid-item grid-image-1 fade-in stagger-2 ${isGridVisible ? 'visible' : ''}`}>
            <img src={secondSection} alt="Indus Trade Factory Building" className={`story-image image-reveal ${isGridVisible ? 'visible' : ''}`} />
          </div>
          
          {/* Row 2 */}
          <div className={`grid-item grid-tagline fade-in stagger-3 ${isGridVisible ? 'visible' : ''}`}>
            <p className={`story-tagline text-reveal ${isGridVisible ? 'visible' : ''}`}>
              <span className="tagline-line-1">Blending Tradition,</span>
              <span className="tagline-line-2">Technology, and Trust.</span>
            </p>
          </div>
          
          <div className={`grid-item grid-image-2 fade-in stagger-4 ${isGridVisible ? 'visible' : ''}`}>
            <img src={secondSection1} alt="Woodworking Workshop" className={`story-image image-reveal ${isGridVisible ? 'visible' : ''}`} />
          </div>
          
          <div className={`grid-item grid-footer fade-in stagger-5 ${isGridVisible ? 'visible' : ''}`}>
            <p className={`story-footer-text text-reveal ${isGridVisible ? 'visible' : ''}`}>
              25 years of experience in the industry, modern production plant & machinery, a dedicated team of professionally qualified youth, inspired by it's overwhelming success during last 15 years and looking to the phenomenal growth in the worldwide demand for 'correct' Indian furniture.
            </p>
          </div>
        </div>
        
        {/* Mobile Layout for <= 480px */}
        <div ref={mobileRef} className={`story-mobile ${isMobileVisible ? 'visible' : ''}`}>
          <h2 className={`story-title text-reveal ${isMobileVisible ? 'visible' : ''}`}>
            <span className="title-line-1">THE INDUS</span>
            <span className="title-line-2">TRADE STORY</span>
          </h2>
          
          <p className={`story-tagline text-reveal stagger-1 ${isMobileVisible ? 'visible' : ''}`}>
            Blending Tradition, Technology, and Trust.
          </p>
          
          <div className={`story-image-container fade-in stagger-2 ${isMobileVisible ? 'visible' : ''}`}>
            <img src={secondSection} alt="Indus Trade Factory Building" className={`story-image image-reveal ${isMobileVisible ? 'visible' : ''}`} />
          </div>
          
          <p className={`story-description text-reveal stagger-3 ${isMobileVisible ? 'visible' : ''}`}>
            Indus Trade is a professionally managed trade only organization intending to establish Indian Furniture as the trendsetter in world furniture marketplace.
          </p>
          
          <div className={`story-image-container fade-in stagger-4 ${isMobileVisible ? 'visible' : ''}`}>
            <img src={secondSection1} alt="Woodworking Workshop" className={`story-image image-reveal ${isMobileVisible ? 'visible' : ''}`} />
          </div>
          
          <p className={`story-footer-text text-reveal stagger-5 ${isMobileVisible ? 'visible' : ''}`}>
            25 years of experience in the industry, modern production plant & machinery, a dedicated team of professionally qualified youth, inspired by it's overwhelming success during last 15 years and looking to the phenomenal growth in the worldwide demand for 'correct' Indian furniture.
          </p>
        </div>
        
        <div className="story-footer">
          <p className="story-footer-text">
            25 years of experience in the industry, modern production plant & machinery, a dedicated team of professionally qualified youth, inspired by it's overwhelming success during last 15 years and looking to the phenomenal growth in the worldwide demand for 'correct' Indian furniture.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
